module.exports = __webpack_public_path__ + "static/media/rating-star-half.add31164.svg";